import { render, staticRenderFns } from "./PDFSingle.vue?vue&type=template&id=4de618b8&"
import script from "./PDFSingle.vue?vue&type=script&lang=js&"
export * from "./PDFSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports